/**
 * Colores de gráfica leídos de los tokens del panel — plan 27_09_2026 §4.2.
 *
 * `chart.js` recibe los colores como valores JS, no como CSS, así que sin esto
 * el dashboard tenía su paleta escrita a mano en el `<script>` y quedaba fuera
 * del sistema de diseño: cambiar la marca obligaba a editar dos sitios.
 * Aquí se leen las variables `--adm-chart-*` de `admin.css`, que siguen siendo
 * la única fuente.
 */

const FALLBACK = ['#2E8A99', '#526D82', '#46B5BE', '#344F5C', '#8FB8C4', '#9DB2BF', '#1F6473', '#6E8CA0'];
const TOKEN_COUNT = 8;

let cache = null;

/** Lee un token del `:root`; devuelve `null` si no hay DOM o no está definido. */
function readToken(name) {
  if (typeof window === 'undefined' || !document?.documentElement) return null;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name);
  return value ? value.trim() || null : null;
}

/**
 * Serie cromática del panel, en orden. Se cachea: `getComputedStyle` fuerza
 * un reflow y el dashboard recalcula los datasets en cada filtro.
 */
export function chartPalette() {
  if (cache) return cache;

  const colors = [];
  for (let i = 1; i <= TOKEN_COUNT; i += 1) {
    colors.push(readToken(`--adm-chart-${i}`) || FALLBACK[i - 1]);
  }
  cache = colors;
  return cache;
}

/** Color n-ésimo, ciclando si se piden más series que colores hay. */
export function chartColor(index) {
  const palette = chartPalette();
  return palette[index % palette.length];
}

/** Colores con significado fijo, para que ingresos y gastos no bailen. */
export function semanticChartColors() {
  return {
    ingresos: readToken('--adm-chart-3') || FALLBACK[2],
    gastos: readToken('--adm-chart-2') || FALLBACK[1],
  };
}

export default chartPalette;
